import { inlines } from './inlines';
export const decisionItem = (node, {
  context
} = {}) => {
  let result = '';
  node.forEach(n => {
    result += `* <> ${inlines(n, {
      context
    })}`;
  });
  return result;
};